module.exports = __webpack_public_path__ + "static/media/Slice14@2x.dfeeda54.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice14@2x.png
// module id = 1442
// module chunks = 0